import axios from 'axios'
// axios used only for apiClient.create — refresh uses fetch to avoid CORS via Vite proxy

let authInitialized = false
export function setAuthInitialized() { authInitialized = true }

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? 'http://localhost:8000',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

apiClient.interceptors.request.use((config) => {
  if (!config.headers.Authorization) {
    const token = (window as Window & { __fasico_token?: string }).__fasico_token
      || sessionStorage.getItem('fasico_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  }
  return config
})

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config as typeof error.config & { _retry?: boolean }
    const isAuthRoute =
      originalRequest?.url?.includes('/auth/login') ||
      originalRequest?.url?.includes('/auth/register') ||
      originalRequest?.url?.includes('/auth/refresh')

    if (error.response?.status === 401 && !isAuthRoute && !originalRequest._retry) {
      if (!authInitialized) {
        return Promise.reject(error)
      }
      originalRequest._retry = true
      try {
        const response = await fetch(
          `${import.meta.env.VITE_API_URL ?? 'http://localhost:8000'}/api/v1/auth/refresh`,
          { method: 'POST', credentials: 'include' }
        )
        if (!response.ok) throw new Error('Refresh failed')
        const data = await response.json() as { access_token: string }
        ;(window as Window & { __fasico_token?: string }).__fasico_token = data.access_token
        sessionStorage.setItem('fasico_token', data.access_token)
        originalRequest.headers.Authorization = `Bearer ${data.access_token}`
        return apiClient(originalRequest)
      } catch {
        sessionStorage.setItem('fasico:redirect_after_login', window.location.pathname)
        window.dispatchEvent(new Event('fasico:logout'))
        return Promise.reject(new Error('Tu sesión expiró. Por favor inicia sesión nuevamente.'))
      }
    }

    if (!error.response) {
      return Promise.reject(new Error('Sin conexión. Verifica tu internet.'))
    }

    const status = error.response?.status

    if (status >= 500) {
      import('../utils/sentry').then(({ Sentry }) => {
        Sentry.captureException(error, {
          tags: { api_status: String(status) },
        })
      }).catch(() => {})
    }
    const messages: Record<number, string> = {
      401: 'Correo o contraseña incorrectos.',
      422: 'Datos inválidos. Verifica los campos.',
      404: 'No encontrado.',
      500: 'Error del servidor. Intenta nuevamente.',
      403: 'No tienes permiso para realizar esta acción.',
    }
    const message = messages[status] ?? `Error inesperado. Intenta nuevamente.`
    return Promise.reject(new Error(message))
  }
)
